var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepageOurVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 426,
    viewBox: "0 0 1440 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6784_6671)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M654.675 426H1442.35V169.278H1127.81H428.635L654.675 426Z",
    fill: "#290097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.43 169.278L1259.66 139.153L1298.36 147.281L1339.93 121.932L1387.22 76.0283L1443 122.653L1442.35 169.278H1189.43Z",
    fill: "#290097"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M975.875 426L1083.85 265.384L1137.02 278.297L1235.3 205.134L1289.76 216.615L1442.35 0V426H975.875Z",
    fill: "#2703A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.76 216.615H1316.22L1442.35 0L1289.76 216.615Z",
    fill: "#4EA7BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.85 265.384L1137.02 297.634V278.297L1083.85 265.384Z",
    fill: "#4EA7BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.02 297.635L1229.56 341.422L1216.44 372.98L1316.22 420.316L1189.43 377.278L1216.44 345.72L1137.02 297.635Z",
    fill: "#1389A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.22 216.615L1273.99 251.047L1431.65 281.509L1301.23 249.062L1442.35 0L1316.22 216.615Z",
    fill: "#1389A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.66 139.153L1316.22 167.564L1304.09 153.359L1329.89 132.383L1298.36 147.281L1259.66 139.153Z",
    fill: "#117890"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.6 289.553L985.671 426H975.875L1067.6 289.553Z",
    fill: "#4EA7BB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.02 169.278L910.898 426H928.103L1154.02 169.278Z",
    fill: "#1389A4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.02 177.228L1324.31 167.564L1154.02 169.278L1147.02 177.228Z",
    fill: "#0F6F85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M428.635 169.278C427.428 106.163 377.055 54.322 313.275 52.112C247.306 49.8271 191.966 101.499 189.683 167.527C189.664 168.107 189.655 168.697 189.646 169.278H428.635Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M413.618 169.278C412.411 114.225 368.429 69.0612 312.752 67.1227C255.063 65.1188 206.683 110.311 204.681 168.042C204.662 168.454 204.662 168.866 204.653 169.268H413.609L413.618 169.278Z",
    fill: "#DF810F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M385.223 169.278C384.007 129.47 352.112 96.9108 311.779 95.5156C269.751 94.0547 234.508 126.97 233.057 169.035C233.057 169.119 233.057 169.194 233.057 169.278H385.232H385.223Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M365.632 169.278C364.425 139.986 340.848 116.126 311.096 115.096C280.024 114.019 253.949 138.245 252.639 169.278H365.632Z",
    fill: "#DF810F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M345.647 169.278C344.459 150.718 329.368 135.735 310.413 135.08C290.597 134.396 273.934 149.613 272.652 169.278H345.647Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329.508 169.278C328.357 159.371 320.115 151.514 309.851 151.158C299.101 150.784 290.007 158.771 288.781 169.278H329.508Z",
    fill: "#DF810F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M312.461 169.278C311.741 168.286 310.6 167.602 309.28 167.565C307.849 167.518 306.577 168.202 305.8 169.278H312.461Z",
    fill: "#DF810F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M788.325 426H0.655029V169.278H315.194L787.67 364.374L788.325 426Z",
    fill: "#290097"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M253.566 169.278L183.34 139.153L144.643 147.281L103.075 121.932L55.7803 76.0283L0 122.653L0.645562 169.278H253.566Z",
    fill: "#290097"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M467.125 426L359.148 265.384L305.978 278.297L207.703 205.134L153.241 216.615L0.645508 0V426H467.125Z",
    fill: "#2703A5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 216.615H126.783L0.645508 0L153.241 216.615Z",
    fill: "#4EA7BB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M359.148 265.384L305.978 297.634V278.297L359.148 265.384Z",
    fill: "#4EA7BB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M305.978 297.635L213.438 341.422L226.564 372.98L126.783 420.316L253.566 377.278L226.564 345.72L305.978 297.635Z",
    fill: "#1389A4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.783 216.615L169.006 251.047L11.3487 281.509L141.771 249.062L0.645508 0L126.783 216.615Z",
    fill: "#1389A4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.34 139.153L126.783 167.564L138.908 153.359L113.104 132.383L144.643 147.281L183.34 139.153Z",
    fill: "#117890"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M375.39 289.553L457.329 426H467.125L375.39 289.553Z",
    fill: "#4EA7BB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M288.969 169.278L532.093 426H514.897L288.969 169.278Z",
    fill: "#1389A4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M295.976 177.228L118.69 167.564L288.969 169.278L295.976 177.228Z",
    fill: "#0F6F85"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.23 426H532.093L288.969 169.278H428.635L1372.23 426Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M506.532 209.179L577.198 217.092L577.498 215.435L508.45 198.42L506.532 209.179Z",
    fill: "#0C3879"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M502.369 209.825L505.803 210.434C506.533 210.565 507.225 210.078 507.356 209.347L509.283 198.541C509.414 197.811 508.928 197.118 508.198 196.987L504.764 196.378L502.369 209.825Z",
    fill: "#1E4D94"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M522.428 201.866L521.072 206.595L521.596 201.66L522.428 201.866Z",
    fill: "#002152"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M535.003 204.966L534.189 209.573L536.022 205.219L535.003 204.966Z",
    fill: "#002152"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M547.353 208.009L547.222 210.621L547.877 208.131L547.353 208.009Z",
    fill: "#002152"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M557.036 210.387L556.203 212.86L556.531 210.266L557.036 210.387Z",
    fill: "#002152"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M560.367 216.671L559.787 213.131L562.313 212.176L563.847 213.112L561.695 214.826C561.695 214.826 564.053 215.032 561.536 215.641L561.106 216.605L560.367 216.68V216.671Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M557.251 237.235L562.594 216.671L560.021 215.875L549.654 235.446C548.485 237.656 548.12 241.065 550.29 242.31C552.948 243.846 554.997 243.481 557.251 237.235Z",
    fill: "#002A69"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M616.456 290.489C616.053 290.489 615.735 290.161 615.735 289.768V285.957H614.164C613.761 285.957 613.443 285.629 613.443 285.236C613.443 284.842 613.771 284.515 614.164 284.515H617.176V289.768C617.176 290.171 616.849 290.489 616.456 290.489Z",
    fill: "#0C3879"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M578.106 222.505L584.636 213.749L586.124 213.721C586.124 213.721 589.258 213.655 587.92 216.774L586.311 220.529L590.83 227.093L579.378 233.292L580.688 224.125C580.688 224.125 577.601 224.293 578.096 222.514L578.106 222.505Z",
    fill: "#C8E1FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M578.031 210.659C578.031 210.659 575.262 220.997 578.443 223.779C578.443 223.779 583.869 224.144 585.918 214.405C585.918 214.405 582.541 209.039 578.04 210.659H578.031Z",
    fill: "#EDF6FB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M577.994 215.875L575.926 218.563C575.795 218.731 575.917 218.965 576.122 218.975L578.199 219.012L577.994 215.875Z",
    fill: "#EDF6FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6784_6671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 576,
    y: 218,
    width: 2,
    height: 2
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M576.88 218.946L577.816 219.012L576.918 219.583L576.88 218.946Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6784_6671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.404 219.733L577.816 219.012L577.572 219.789L577.404 219.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.395 219.732L577.806 219.002L577.816 219.011L577.404 219.732H577.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.385 219.723L577.797 219.002H577.806L577.395 219.732L577.385 219.723Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.376 219.723L577.788 219.002H577.797L577.385 219.723H577.376Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.367 219.724L577.778 218.993L577.788 219.003L577.376 219.724H577.367Z",
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.357 219.714L577.769 218.993H577.778L577.367 219.724L577.357 219.714Z",
    fill: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.348 219.714L577.76 218.993H577.769L577.357 219.714H577.348Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.339 219.714L577.75 218.983L577.76 218.993L577.348 219.714H577.339Z",
    fill: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.329 219.704L577.741 218.983H577.75L577.338 219.714L577.329 219.704Z",
    fill: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.32 219.704L577.731 218.983H577.741L577.329 219.704H577.32Z",
    fill: "#F7FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.311 219.705L577.713 218.975L577.732 218.984L577.32 219.705H577.311Z",
    fill: "#F6FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.301 219.705L577.703 218.975H577.713L577.31 219.705H577.301Z",
    fill: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.292 219.696L577.694 218.975H577.703L577.301 219.705L577.292 219.696Z",
    fill: "#F4F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.282 219.695L577.685 218.965L577.694 218.974L577.292 219.695H577.282Z",
    fill: "#F3F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.264 219.695L577.675 218.965H577.685L577.282 219.695H577.264Z",
    fill: "#F2F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.254 219.686L577.666 218.965H577.675L577.264 219.695L577.254 219.686Z",
    fill: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.245 219.686L577.657 218.956L577.666 218.965L577.254 219.686H577.245Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.236 219.686L577.647 218.956H577.657L577.245 219.686H577.236Z",
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.226 219.677L577.638 218.956H577.647L577.236 219.686L577.226 219.677Z",
    fill: "#EEF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.217 219.677L577.629 218.956H577.638L577.226 219.677H577.217Z",
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.208 219.677L577.619 218.946L577.629 218.956L577.217 219.677H577.208Z",
    fill: "#ECF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.198 219.667L577.61 218.946H577.619L577.208 219.677L577.198 219.667Z",
    fill: "#EBF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.189 219.667L577.6 218.946H577.61L577.198 219.667H577.189Z",
    fill: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.179 219.667L577.591 218.937L577.6 218.946L577.189 219.667H577.179Z",
    fill: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.17 219.658L577.582 218.937H577.591L577.179 219.667L577.17 219.658Z",
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.161 219.658L577.573 218.937H577.582L577.17 219.658H577.161Z",
    fill: "#E7F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.151 219.658L577.563 218.928L577.572 218.937L577.161 219.658H577.151Z",
    fill: "#E6F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.142 219.658L577.554 218.928H577.563L577.151 219.658H577.142Z",
    fill: "#E5F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.133 219.649L577.544 218.928H577.554L577.142 219.658L577.133 219.649Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.123 219.648L577.535 218.918L577.544 218.927L577.133 219.648H577.123Z",
    fill: "#E3EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.114 219.648L577.526 218.918H577.535L577.123 219.648H577.114Z",
    fill: "#E2EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.105 219.639L577.516 218.918H577.526L577.114 219.648L577.105 219.639Z",
    fill: "#E1EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.095 219.64L577.507 218.909L577.516 218.919L577.105 219.64H577.095Z",
    fill: "#E0EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.086 219.64L577.498 218.909H577.507L577.095 219.64H577.086Z",
    fill: "#DFEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.077 219.63L577.488 218.909H577.498L577.086 219.64L577.077 219.63Z",
    fill: "#DEEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.067 219.63L577.479 218.899L577.488 218.909L577.077 219.63H577.067Z",
    fill: "#DDECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.058 219.63L577.469 218.899H577.479L577.067 219.63H577.058Z",
    fill: "#DCECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.049 219.62L577.46 218.899H577.47L577.058 219.63L577.049 219.62Z",
    fill: "#DBEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.039 219.62L577.451 218.899H577.46L577.048 219.62H577.039Z",
    fill: "#DAEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.03 219.62L577.441 218.89L577.451 218.899L577.039 219.62H577.03Z",
    fill: "#D9EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.021 219.611L577.432 218.89H577.442L577.03 219.62L577.021 219.611Z",
    fill: "#D8E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.011 219.611L577.423 218.89H577.432L577.02 219.611H577.011Z",
    fill: "#D7E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.002 219.611L577.413 218.881L577.423 218.89L577.011 219.611H577.002Z",
    fill: "#D6E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.992 219.602L577.395 218.881H577.413L577.002 219.611L576.992 219.602Z",
    fill: "#D5E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.983 219.602L577.385 218.881H577.395L576.992 219.602H576.983Z",
    fill: "#D4E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.974 219.602L577.376 218.871L577.385 218.88L576.983 219.602H576.974Z",
    fill: "#D3E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.964 219.592L577.367 218.871H577.376L576.974 219.602L576.964 219.592Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.946 219.592L577.357 218.871H577.367L576.964 219.592H576.946Z",
    fill: "#D1E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.936 219.593L577.348 218.862L577.357 218.872L576.946 219.593H576.936Z",
    fill: "#D0E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.927 219.593L577.339 218.862H577.348L576.936 219.593H576.927Z",
    fill: "#CFE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.917 219.583L577.329 218.862H577.339L576.927 219.593L576.917 219.583Z",
    fill: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.908 219.583L577.32 218.853L577.329 218.862L576.918 219.583H576.908Z",
    fill: "#CDE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.899 219.583L577.31 218.853H577.32L576.908 219.583H576.899Z",
    fill: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.889 219.574L577.301 218.853H577.31L576.899 219.583L576.889 219.574Z",
    fill: "#CBE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.88 219.573L577.292 218.843L577.301 218.852L576.889 219.573H576.88Z",
    fill: "#CAE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.871 219.573L577.283 218.843H577.292L576.88 219.573H576.871Z",
    fill: "#C9E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.861 219.564L577.273 218.843H577.282L576.871 219.573L576.861 219.564Z",
    fill: "#C8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.852 219.564L577.264 218.843H577.273L576.861 219.564H576.852Z",
    fill: "#C7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.843 219.564L577.254 218.834L577.264 218.843L576.852 219.564H576.843Z",
    fill: "#C5DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.833 219.555L577.245 218.834H577.254L576.843 219.564L576.833 219.555Z",
    fill: "#C4DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.824 219.555L577.236 218.834H577.245L576.833 219.555H576.824Z",
    fill: "#C3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.815 219.555L577.226 218.824L577.236 218.834L576.824 219.555H576.815Z",
    fill: "#C2DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.805 219.545L577.217 218.824H577.226L576.815 219.555L576.805 219.545Z",
    fill: "#C1DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.796 219.545L577.208 218.824H577.217L576.805 219.545H576.796Z",
    fill: "#C0DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.787 219.546L577.198 218.815L577.208 218.825L576.796 219.546H576.787Z",
    fill: "#BFDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.777 219.546L577.189 218.815H577.198L576.786 219.546H576.777Z",
    fill: "#BEDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.768 219.536L577.179 218.815H577.189L576.777 219.546L576.768 219.536Z",
    fill: "#BDDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.759 219.536L577.17 218.806L577.18 218.815L576.768 219.536H576.759Z",
    fill: "#BCDAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.749 219.536L577.161 218.806H577.17L576.758 219.536H576.749Z",
    fill: "#BBDAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.74 219.527L577.151 218.806H577.161L576.749 219.536L576.74 219.527Z",
    fill: "#BAD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.73 219.527L577.142 218.797L577.151 218.806L576.74 219.527H576.73Z",
    fill: "#B9D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.721 219.527L577.133 218.797H577.142L576.73 219.527H576.721Z",
    fill: "#B8D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.712 219.518L577.123 218.797H577.133L576.721 219.527L576.712 219.518Z",
    fill: "#B7D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.721 219.471L577.114 218.787L577.123 218.796L576.712 219.518L576.721 219.471Z",
    fill: "#B6D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.74 219.433L577.105 218.787H577.114L576.721 219.471L576.74 219.433Z",
    fill: "#B5D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.749 219.386L577.086 218.787H577.105L576.74 219.433L576.749 219.386Z",
    fill: "#B4D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.768 219.34L577.077 218.787H577.086L576.749 219.386L576.768 219.34Z",
    fill: "#B3D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.777 219.302L577.067 218.777L577.077 218.787L576.768 219.339L576.777 219.302Z",
    fill: "#B2D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.786 219.255L577.058 218.777H577.067L576.777 219.302L576.786 219.255Z",
    fill: "#B1D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.805 219.208L577.049 218.777H577.058L576.787 219.255L576.805 219.208Z",
    fill: "#B0D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.815 219.171L577.039 218.769L577.048 218.778L576.805 219.209L576.815 219.171Z",
    fill: "#AFD3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.833 219.124L577.03 218.769H577.039L576.815 219.171L576.833 219.124Z",
    fill: "#AED2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.843 219.078L577.02 218.769H577.03L576.833 219.124L576.843 219.078Z",
    fill: "#ADD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.862 219.04L577.011 218.759L577.021 218.768L576.843 219.077L576.862 219.04Z",
    fill: "#ACD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.871 218.993L577.002 218.759H577.011L576.861 219.04L576.871 218.993Z",
    fill: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.88 218.946L576.992 218.759H577.002L576.871 218.993L576.88 218.946Z",
    fill: "#AAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.993 218.759L576.88 218.947L576.946 218.74L576.993 218.759Z",
    fill: "#AAD0FF"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M561.826 359.26L561.695 362.098L560.236 362.032L560.301 360.609L559.637 360.581L559.572 362.004L555.867 361.826C554.126 361.601 553.612 359.963 553.612 359.963L556.381 360.094L557.728 359.401L558.327 359.092",
    fill: "#002152"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M592.037 358.362L591.962 359.907L591.166 359.869L591.204 359.092L590.839 359.073L590.802 359.851L588.79 359.757C587.845 359.635 587.564 358.746 587.564 358.746L589.071 358.82L589.801 358.446L590.128 358.277",
    fill: "#002152"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M594.937 283.082C594.937 283.082 597.66 287.23 592.879 293.523L593.3 317.402C593.3 317.402 599.288 322.777 591.868 357.987L590.119 358.961L582.765 323.152L574.111 289.881L583.672 282.923L594.918 283.091L594.937 283.082Z",
    fill: "#002152"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M589.539 224.93L584.168 226.663L579.06 228.442L573.044 244.464L572.352 256.497L568.544 284.768L598.408 285.227L592.57 263.211L600.223 244.726C600.223 244.726 602.749 235.68 593.693 228.957L590.54 224.78L589.557 224.921L589.539 224.93Z",
    fill: "#2703A5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M591.326 285.123L580.594 283.466L568.525 284.777L563.726 324.238L557.719 359.953H561.022C566.392 349.924 578.05 331.673 573.082 325.128L587.349 297.615C587.349 297.615 592.71 291.922 591.326 285.123Z",
    fill: "#2703A5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M591.326 285.124L568.787 286.014L569.012 287.119L593.122 285.152L591.326 285.124Z",
    fill: "#002152"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M591.85 268.314L595.676 285.61L593.833 285.142L591.85 268.314Z",
    fill: "#0C3879"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M593.216 228.451L584.515 228.826L592.458 227.927L593.974 228.976",
    fill: "#0C3879"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M579.93 210.621L580.211 213.702C580.211 213.702 581.296 215.098 581.306 216.221C581.306 216.221 585.609 213.684 582.129 219.302V222.102L584.842 222.926L588.341 222.627L590.184 213.936L590.156 208.056L579.93 208.28V210.631V210.621Z",
    fill: "#002868"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M579.256 210.527L577.778 211.211L577.498 208.243L590.166 208.046L590.184 211.286L580.22 213.702C580.22 213.702 580.342 211.164 579.256 210.537V210.527Z",
    fill: "#002868"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M577.778 211.212C577.778 211.212 580.202 211.202 580.22 213.693L582.363 211.586L582.222 210.641L581.268 209.433L578.443 209.985L577.778 211.202V211.212Z",
    fill: "#002868"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M599.624 238.274L603.619 256.319L612.536 283.626L609.121 283.635L588.921 244.183L599.624 238.274Z",
    fill: "#002A69"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M593.936 231.616L598.361 241.252L590.315 263.118L596.958 241.627L593.936 231.616Z",
    fill: "#0C3879"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M580.033 244.642L575.87 249.615L572.099 269.57L569.882 286.135L568.534 284.796L573.044 244.483L574.129 238.284L581.895 232.956L580.183 231.008C580.183 231.008 584.412 232.628 584.533 234.594C584.655 236.561 583.757 243.247 580.033 244.652V244.642Z",
    fill: "#002152"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M627.224 288.804H597.847V308L623.847 308.094L627.224 306.942V288.804Z",
    fill: "#002152"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M627.224 288.804L623.847 289.469V308.094L627.224 306.942V288.804Z",
    fill: "#0C3879"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M623.847 289.469L597.847 288.804H627.224L623.847 289.469Z",
    fill: "#061A38"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M610.711 291.604C610.711 292.484 610 293.196 609.121 293.196C608.241 293.196 607.53 292.484 607.53 291.604C607.53 290.723 608.241 290.012 609.121 290.012C610 290.012 610.711 290.723 610.711 291.604Z",
    fill: "#061A38"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M609.121 292.334C608.718 292.334 608.4 292.006 608.4 291.613V284.89H612.302C612.704 284.89 613.022 285.217 613.022 285.611C613.022 286.004 612.695 286.332 612.302 286.332H609.851V291.604C609.851 292.006 609.523 292.325 609.13 292.325L609.121 292.334Z",
    fill: "#0C3879"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M612.536 283.625L615.473 286.537L612.068 288.017L609.121 283.634L612.536 283.625Z",
    fill: "#C8E1FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M579.06 228.451L562.603 249.118C562.603 249.118 562.846 252.798 572.352 256.516C581.848 260.234 581.361 268.652 581.418 270.956L583.85 268.324C583.85 268.324 587.284 257.087 568.796 249.708L579.069 228.461L579.06 228.451Z",
    fill: "#ED1C24"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M568.787 249.699L562.603 249.118L579.06 228.451C579.06 228.451 572.183 243.387 568.787 249.699Z",
    fill: "#CF1820"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M583.804 230.025L552.573 233.986C552.573 233.986 545.397 238.677 551.385 242.835L577.357 243.378C577.357 243.378 591.513 240.887 587.153 231.822C586.545 230.568 585.188 229.856 583.804 230.034V230.025Z",
    fill: "#0C3879"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M590.137 358.961L788.316 426H603.76L557.719 359.963H561.022L607.53 396.615L649.894 398.797L587.565 358.746L590.137 358.961Z",
    fill: "#E6E7E8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6784_6671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1443,
    height: 426,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageOurVision);
export default __webpack_public_path__ + "static/media/HomepageOurVision.77e85cb92b95a5d1e68a1ec7fa4575d9.svg";
export { ForwardRef as ReactComponent };